var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import { useNavigate } from 'react-router-dom';
import { PAGINAS, ROUTES, FUNCIONALIDADES } from '../../../routes';
import { MODOS, getCodigoOfertaFormatada, getDataFormatada } from '../../../utils';
import { useAuth } from '../../../contexts/auth/AuthContext';
import GridBase from '../../../components/grid_base';
import { FiltrosVagas } from '../components/FiltrosVagas';
import { getOfertasVagasTrabalhos, getCombosListarOfertasVagas } from './ofertas_vagas_trabalho.service';
var COLUNAS = [
    {
        field: 'id',
        headerName: 'Código',
        description: 'Código da Oferta',
        width: 100,
        valueGetter: function (value) { return getCodigoOfertaFormatada(value); },
    },
    { field: 'descricao', headerName: 'Descrição', width: 200 },
    {
        field: 'instituicao',
        headerName: 'Instituição',
        width: 250,
        valueGetter: function (_value, row) { var _a, _b; return (_b = (_a = row.instituicao) === null || _a === void 0 ? void 0 : _a.dados) === null || _b === void 0 ? void 0 : _b.razao_social; },
    },
    {
        field: 'data_inicio',
        headerName: 'Data Início',
        width: 100,
        valueGetter: function (value) { return (value ? getDataFormatada(value) : ''); },
    },
    { field: 'vagas_qtd', headerName: 'QTD. Solicitadas', width: 150 },
    { field: 'vagas_abertas', headerName: 'Abertas', width: 100 },
    { field: 'vagas_atendidas_parcialmente', headerName: 'P. Atendidas', width: 110 },
    { field: 'vagas_finalizadas', headerName: 'Finalizadas', width: 130 },
    { field: 'vagas_encerradas', headerName: 'Encerradas', width: 110 },
];
export var OfertasVagasTrabalhosListar = function () {
    var navigate = useNavigate();
    var getFuncionalidadeExiste = useAuth().getFuncionalidadeExiste;
    // Ícone extra de "Editar Vagas" que fica no INÍCIO da coluna de ações
    var opcaoEditarVagas = useMemo(function () { return function (params) { return (_jsx(Tooltip, __assign({ title: 'Editar Vagas', componentsProps: { tooltip: { sx: { fontSize: '0.9rem' } } } }, { children: _jsx(Box, __assign({ ml: 1 }, { children: _jsx(IconButton, __assign({ style: { padding: 0, margin: 0, paddingRight: 1, marginTop: -1 }, onClick: function () {
                    navigate("".concat(ROUTES.OFERTAS_VAGAS_TRABALHO_VAGAS, "/").concat(params.row.id, "/").concat(MODOS.ALTERAR));
                } }, { children: _jsx(GroupAddIcon, { fontSize: 'medium' }) })) })) }))); }; }, [navigate]);
    return (_jsx(GridBase, { pagina: PAGINAS.OFERTAS_VAGAS_TRABALHO, paginaPermissao: FUNCIONALIDADES.OFERTAS_VAGAS_TRABALHO, rota: ROUTES.OFERTAS_VAGAS_TRABALHO, columns: COLUNAS, opcaoAdicionalInicioGrid: opcaoEditarVagas, filtrosIniciais: {
            status: '-1',
            instituicao: -1,
            perfilLaboral: -1,
            dataInicio: '',
            dataFim: '',
        }, fetchData: function (textoBusca, filtros, paginationModel) {
            var _a, _b;
            // Cálculo dinâmico do regime
            var tipoRegime = null;
            var temFechado = getFuncionalidadeExiste(FUNCIONALIDADES.ATENDIMENTOS_REGIME_FECHADO);
            var temSemiaberto = getFuncionalidadeExiste(FUNCIONALIDADES.ATENDIMENTOS_REGIME_SEMIABERTO);
            if (temFechado && !temSemiaberto) {
                tipoRegime = 'Fechado';
            }
            else if (!temFechado && temSemiaberto) {
                tipoRegime = 'Semiaberto';
            }
            return getOfertasVagasTrabalhos(textoBusca === '' ? null : textoBusca, filtros.status === '-1' ? null : filtros.status, filtros.instituicao === -1 ? null : (_a = filtros.instituicao) === null || _a === void 0 ? void 0 : _a.toString(), filtros.perfilLaboral === -1 ? null : (_b = filtros.perfilLaboral) === null || _b === void 0 ? void 0 : _b.toString(), filtros.dataInicio === '' ? null : filtros.dataInicio, filtros.dataFim === '' ? null : filtros.dataFim, tipoRegime, paginationModel);
        }, renderFiltros: function (filtros, atualizarFiltros) { return (_jsx(FiltrosVagas, { filtrosAtuais: filtros, atualizarFiltros: atualizarFiltros, getCombosListar: getCombosListarOfertasVagas })); } }));
};
export default OfertasVagasTrabalhosListar;
